define('lq/events/actions/raiseEvent',[
        'lq/events/actions/eventAction',
        'jquery'
], function (EventAction, $) {
    'use strict';

    function RaiseEvent(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(RaiseEvent, EventAction);

    RaiseEvent.typeName = 'RaiseEvent';

    RaiseEvent.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };
    
    RaiseEvent.prototype.execute = function (continuation) {            
        if (this.eventData.eventReceiver) {
            var drop = this.piping.dropFactory.findDropById(this.eventData.eventReceiver);

            if (drop) {
                var eventObj = {
                    eventName: this.eventData.eventName,
                    args: [this.getEventValue()]
                };
                drop.triggerEventForChild(eventObj);
            }

            continuation();
        } else {
            this.piping.eventing.publish(this.eventData.eventName, this.eventSource, this.getEventValue(), continuation, this.getEventActionIdentifier());
        } 
    };

    RaiseEvent.prototype.getEventValue = function () {
        if (this.eventData.eventParameter)
            return this.piping.parameters.getValue(this.eventData.eventParameter);
        return null;
    };

    return RaiseEvent;
});
